/**
 * the status of the cookie banner
 */
export enum ConsentStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
}
